import { page } from '@patrianna/analytics'
import { usePageViewTracker } from '@patrianna/shared-hooks'
import { getCookie } from '@patrianna/shared-utils/cookie'
import { setUser } from '@sentry/nextjs'
import { useEffect } from 'react'

import { graphytePageView } from 'analyticActions/graphyte/events'
import useDynamoUrl from 'hooks/useDynamoUrl'
import useGameDialogByQuery from 'hooks/useGameDialogByQuery'
import useOtpRedirect from 'hooks/useOtpRedirect'
import useSeonInit from 'hooks/useSeonInit'
import useSecureAccountRedirect from 'hooks/useSoftKYCRedirect'
import { useAppSelector } from 'store/hooks'
import { getGraphyteEnabledSelector } from 'store/modules/user/selectors'

export default function useMainLayout() {
  const graphyteEnabled = useAppSelector(getGraphyteEnabledSelector)

  useOtpRedirect()
  useSecureAccountRedirect()
  useGameDialogByQuery()
  useDynamoUrl()
  useSeonInit()

  usePageViewTracker(() => {
    page()
  })

  usePageViewTracker(() => {
    if (graphyteEnabled) {
      graphytePageView()
    }
  }, [graphyteEnabled])

  useEffect(() => {
    const userId = getCookie(`${process.env.BRAND_NAME.toUpperCase()}AID`, document.cookie)

    if (userId) {
      setUser({ id: userId })
    }
  }, [])
}
